import TabMenu from '@/components/tab_menu/TabMenu.vue';
import SideBar from '@/components/side_bar/SideBar.vue';
import ConciergeTable from '@/components/concierge_table/ConciergeTable.vue';
import ConciergeCreate from '@/components/concierge_create/ConciergeCreate.vue';

export default {
  name: 'Concierges',
  components: { TabMenu, SideBar, ConciergeTable, ConciergeCreate },

  data: function() {
    return {
      tabMenu: {
        items: {
          list: {
            label: 'Concierges'
          },
          create: {
            label: 'Create Account'
          }
        },
        currentTab: 'list'
      }
    };
  }
};
